module.exports = __webpack_public_path__ + "static/media/kostadin_ljatkoski.eeee5c8f.jpg";